import { makeStyles } from "@material-ui/core"

const drawerWidth = 230

export const DashboardLayoutStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif"
  },
  appBar: {
    backgroundColor: "rebeccapurple",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  iconButton: {
    color: "white",
  },
  imgIcon: {
    marginBottom: 0,
    height: '30px',
    alignSelf: 'center'
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  siteTitle: {
    marginTop: "1.5rem",
    marginLeft: "1rem",
  },
  successIconButton: {
    color: "lime",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "rebeccapurple",
    color: "white",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    color: "white",
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  linkButton: {
    display: "flex",
    color: "white",
  },
  titleLink: {
    color: 'white',
    cursor: 'pointer'
  },
}))
